import React from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import {
	formatBrandOptions,
	formatProjectOptions,
	formatSampleTypeOptions
} from '@/features/sampleDevelopment/utils';
import { checkAnyUserType, getUserInfo, isAdmin, isFashionDesigner } from '@/utils/Util';

const SendToPdForm = ({
	handleChange,
	requestValues,
	inputErrors,
	brands,
	projectList,
	sampleTypeList,
	selectedComment
}) => {
	const getUser = getUserInfo();
	const isOwner = parseInt(getUser?.id) === parseInt(selectedComment?.postedBy?.id);
	const isDisabledRequiredDate = selectedComment?.postedBy ? !(isAdmin() || isOwner) : false;

	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-3 gap-3">
				<FormGroupWrapper labelTitle="Primary target customer*">
					<CustomDropdown
						title="Select target customer"
						onItemClick={(value) => handleChange('primaryTargetCustomar', value)}
						selectedItem={requestValues?.primaryTargetCustomar?.name}
						items={formatBrandOptions(brands)}
					/>
					{inputErrors?.primaryTargetCustomar && (
						<p className="error">{inputErrors?.primaryTargetCustomar}</p>
					)}
				</FormGroupWrapper>

				<FormGroupWrapper labelTitle="Project name">
					<CustomDropdown
						title="Select Project name"
						onItemClick={(value) => handleChange('projectName', value)}
						selectedItem={requestValues?.projectName?.text}
						items={formatProjectOptions(projectList)}
					/>
				</FormGroupWrapper>

				<FormGroupWrapper labelTitle="Sample type*">
					<CustomDropdown
						title="Select sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(sampleTypeList)}
					/>
					{inputErrors?.sampleType && <p className="error">{inputErrors?.sampleType}</p>}
				</FormGroupWrapper>
			</div>

			<div className={`flied-item d-grid grid-columns-2 gap-3`}>
				<InputWrapper labelTitle="Required date*">
					<InputField
						type="date"
						name="requiredDate"
						withWrapper={false}
						withLabel={false}
						value={requestValues?.requiredDate}
						onChangeHandler={(e) => handleChange('requiredDate', e.target.value)}
						errors={inputErrors?.requiredDate}
						disabled={isDisabledRequiredDate}
						className={`${isDisabledRequiredDate ? 'cursor-none' : ''}`}
					/>
				</InputWrapper>

				<InputWrapper
					labelTitle={`Expected Order Date${checkAnyUserType(['ACCOUNT_MANAGER']) ? '*' : ''}`}
				>
					<InputField
						type="date"
						name="expectedOrderDate"
						withWrapper={false}
						withLabel={false}
						value={requestValues?.expectedOrderDate}
						onChangeHandler={(e) => handleChange('expectedOrderDate', e.target.value)}
						disabled={
							isFashionDesigner() ||
							checkAnyUserType(['PRODUCT_DEVELOPMENT', 'GARMENTS_TECH', 'GRAPHICS_DESIGNER'])
						}
						className={`${isFashionDesigner() ? 'cursor-none' : ''}`}
						errors={inputErrors?.expectedOrderDate}
					/>
				</InputWrapper>
			</div>
		</React.Fragment>
	);
};

export default SendToPdForm;
